module.exports = __webpack_public_path__ + "img/组1069.87ebfd20.png";